import ReactiveToggle from "../../core/ReactiveToggle";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler.ts";
import { IconSortAscending, IconSortDescending } from "@tabler/icons-react";

const SortOrderController = () => {
  const { set, isActive } = useSearchParamsHandler("order");

  const isAsc = isActive("asc");
  function toggleOrder() {
    if (!isAsc) {
      set("asc");
    } else {
      set("desc");
    }
  }
  return (
    <ReactiveToggle transitional={toggleOrder}>
      {(handleClick, isPending) => (
        <button
          className={`btn glass-blurry ${isPending && "btn-disabled"}`}
          onClick={handleClick}
        >
          {isAsc && <IconSortAscending />}
          {!isAsc && <IconSortDescending />}
        </button>
      )}
    </ReactiveToggle>
  );
};
export default SortOrderController;
